<template>
  <base-page>
    <el-card style="margin: 5px 0px 5px 0px">
      <el-collapse accordion style="border: none">
        <el-collapse-item name="1" style="border: none">
          <template slot="title">
            <div slot="header" class="clearfix">
              <titlu-pagina
                Titlu="Produse"
                @on_add_clicked="show_dialog()"
                :AdaugaVisible="true"
              />
            </div>
          </template>
      <div class="filtre">
        <el-form @submit.prevent.native="refresh_info()">
          <el-row style="margin: 10px" class="input-group">
            <el-col class="input-element">
              <el-form-item label="IdEvio">
                <el-input-number
                  class="full-width"
                  v-model="Filters.IdEvio"
                  :precision="0"
                  :max="999999"
                ></el-input-number>
              </el-form-item>
            </el-col>
            <el-col class="input-element">
              <el-form-item label="Centru productie">
                <el-select class="full-width" v-model="Filters.IdCentruProductie" @change="handleSelectCentru()">
                <el-option label="Toate" value="-1"></el-option>
                  <el-option
                    v-for="item in Info.centre_productie"
                    :key="'centre_productie' + item.Id"
                    :label="item.Nume"
                    :value="item.Id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col class="input-element">
              <el-form-item label="Categorie">
                <el-select class="full-width" v-model="Filters.IdCategorie">
                  <el-option
                    v-for="item in Info.categorii_produse_centru"
                    :key="'categorii_produse' + item.Id"
                    :label="item.Nume"
                    :value="item.Id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col class="input-element">
              <el-form-item label="Nume">
                <el-input v-model="Filters.Nume" />
              </el-form-item>
            </el-col>
            <el-col class="input-element">
              <el-form-item label="Pret Min">
                <el-input-number
                  v-model="Filters.Pret_Min"
                  :precision="2"
                  :max="999999"
                ></el-input-number>
              </el-form-item>
            </el-col>
            <el-col class="input-element">
              <el-form-item label="Pret Max">
                <el-input-number
                  v-model="Filters.Pret_Max"
                  :precision="2"
                  :max="999999"
                ></el-input-number>
              </el-form-item>
            </el-col>
            <el-col class="input-element" :md="12">
              <el-form-item label="Status">
                  <el-select v-model="Filters.Dezactivat" class="full-width">
                  <el-option label="Toate" value="-1"></el-option>
                  <el-option label="Dezactivate" value="1"></el-option>
                  <el-option label="Active" value="0"></el-option>
                  </el-select>
              </el-form-item>
            </el-col>
            <el-col class="input-element">
              <el-form-item label="Serviciu">
                <el-checkbox
                  class="full-width"
                  v-model="Filters.Serviciu"
                  true-label="1"
                  false-label="0"
                >
                  Serviciu
                </el-checkbox>
              </el-form-item>
            </el-col>
            <el-col :md="24">
              <el-button
                type="primary"
                native-type="submit"
                @click="refresh_info()"
              >
                Aplica
              </el-button>
              <el-button type="danger" native-type="submit" @click="reset()">
                Reseteaza
              </el-button>
            </el-col>
          </el-row>
        </el-form>
          </div>
        </el-collapse-item>
      </el-collapse>
    </el-card>

    <el-table :data="Results">
      <el-table-column prop="IdEvio" label="IdEvio"></el-table-column>
      <el-table-column prop="NumeCentru" label="Centru"></el-table-column>
      <el-table-column prop="NumeCategorie" label="Categorie"></el-table-column>
      <el-table-column prop="Nume" label="Nume"></el-table-column>
      <el-table-column prop="Pret" label="Pret"></el-table-column>
      <el-table-column prop="PretAutoutilitar" label="Pret Autoutilitar"></el-table-column>
      <el-table-column prop="PretSupercar" label="Pret Supercar"></el-table-column>
      <el-table-column prop="PretSUV" label="Pret SUV"></el-table-column>
      <el-table-column prop="CostMontaj" label="Cost Montaj"></el-table-column>
      <el-table-column prop="TimpMontaj" label="Timp Montaj"></el-table-column>
      <el-table-column prop="PretSUV" label="Pret SUV"></el-table-column>
      <el-table-column prop="Serviciu" label="Serviciu">
        <template slot-scope="scope">
          {{ scope.row.Serviciu == 0 ? "Nu" : "Da" }}
        </template> </el-table-column>
      <el-table-column prop="Dezactivat" label="Dezactivat">
        <template slot-scope="scope">
          {{ scope.row.Dezactivat == 0 ? "Nu" : "Da" }}
        </template> 
      </el-table-column>
      <el-table-column fixed="right" label="Actiuni" width="110px">
        <template slot-scope="scope">
          <el-tooltip content="Modificare">
            <el-button
              type="primary"
              icon="el-icon-edit"
              circle
              @click="show_dialog(scope.row.Id)"
            />
          </el-tooltip>

          <el-tooltip content="Sterge">
            <el-button
              type="danger"
              icon="el-icon-delete"
              circle
              @click="delete_item(scope.row)"
            />
          </el-tooltip> 
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      @size-change="refresh_info"
      @current-change="refresh_info"
      :page-size.sync="PaginationInfo.PerPage"
      :current-page.sync="PaginationInfo.Page"
      :total="PaginationInfo.RowCount"
      layout="pager"
    />
    <Produse-dialog ref="dlg" @save="refresh_info()" />
  </base-page>
</template>



<script>
import settings from "@/backend/LocalSettings";
import BasePage from "@/pages/Admin/BasePage";
import Produse_dialog from "@/pages/Admin/produse/Produse_dialog.vue";
import TitluPagina from "@/widgets/TitluPagina";

export default {
  name: "produse",
  extends: BasePage,
  components: {
    "base-page": BasePage,
    "Produse-dialog": Produse_dialog,
    "titlu-pagina": TitluPagina,
  },
  data() {
    return {
      Results: [],
      base_url: "",
      Info: {
        categorii_produse: [],
      },
      Filters: {
        IdEvio: "",
        IdCategorie: "",
        IdCentruProductie: "-1",
        Nume: "",
        Pret_Min: "",
        Pret_Max: "",
        Serviciu: "",
        Dezactivat: "",
      },
      OrderBy: {},
      PaginationInfo: {
        Page: 1,
        PerPage: 50,
        RowCount: 0,
        PageSizes: [10, 25, 50, 100, 200],
      },
    };
  },
  methods: {
    async get_info() {
      var response = await this.post("admin/produse/get_info");
      this.Info.categorii_produse = response.categorii_produse;
      this.Info.centre_productie = response.centre_productie;
      if (this.Filters.IdCategorie.length > 0)
        this.Filters.IdCategorie = this.Info.categorii_produse[0].Id;
      this.refresh_info();
      this.handleSelectCentru();
    },

    async refresh_info() {
      var response = await this.post("admin/produse/index", {
        Filters: this.Filters,
        OrderBy: this.OrderBy,
        PaginationInfo: this.PaginationInfo,
      });
      this.Results = response.Results;
      this.PaginationInfo = response.PaginationInfo;
      //
      this.select_menu_item("produse");
    },
    reset() {
      this.Filters = {
        IdEvio: "",
        IdCategorie: "",
        IdCentruProductie: "-1",
        Nume: "",
        Pret_Min: "",
        Pret_Max: "",
        Serviciu: "",
        Dezactivat: "",
      };
      this.refresh_info();
    },  
    handleSelectCentru() {

      if(this.Filters.IdCentruProductie == -1)
        this.Info.categorii_produse_centru =  this.Info.categorii_produse;
       else 
        this.Info.categorii_produse_centru =  this.Info.categorii_produse.filter((value) => value.IdCentruProductie == this.Filters.IdCentruProductie)

      let CentruProdCategorieSelectata = this.Info.categorii_produse.filter((value) => value.Id == this.Filters.IdCategorie);
      let idCentruProdCategorieSelectata = -1;
      if (CentruProdCategorieSelectata.length > 0)
        idCentruProdCategorieSelectata = CentruProdCategorieSelectata[0].IdCentruProductie;

      // sterg categoria daca nu exista in centrul de productie
      if(idCentruProdCategorieSelectata != this.Filters.IdCentruProductie && this.Filters.IdCentruProductie != '-1')
       this.Filters.IdCategorie = '';
    
    },

    async delete_item(item) {
      var confirm = await this.$confirm(`Sunteti sigur ?`, "Warning");
      if (confirm) {
        await this.post("admin/produse/delete_item", { id: item.Id });
        this.refresh_info();
      }
    },

    show_dialog(id) {
      this.$refs.dlg.show_me(id);
    },
  },
  mounted() {
    if (!this.$has_right("Management")) {
      this.$router.push("/no-rights");
      return;
    }
    this.base_url = settings.BASE_URL;
    this.get_info();
  },
};
</script>

<style lang="less" scoped>
.top50 {
  margin-top: 20px;
}

.filtre {
  .el-input-number {
    width: 100% !important;
  }
}

.input-element {
  margin-right: 2%;
  width: 23%;
}

@media only screen and (max-width: 600px) {
  .input-element {
    width: 80%;
  }

  .el-tooltip__popper {
    width: 90%;
  }
}
</style>
